/**
 * @module router/modules/partnership
 * @description 고객사·협력사 신청(리드) 라우트 모듈 — 목록 + 상세.
 * SURINP-218 `/report` 선례와 같이 `meta.roles=['ADMIN']` 으로 roleGuard 가 비-ADMIN 진입을
 * /dashboard 로 리다이렉트합니다. 화면 게이트는 편의일 뿐이고 실제 인가는 customer-back 이 합니다.
 */

const routes = [
  {
    path: '/partnership-inquiries',
    name: '고객사·협력사 신청',
    component: () => import(/* webpackChunkName: "partnershipInquiry" */ '../../views/partnership/PartnershipInquiryManagement.vue'),
    meta: {
      platform: 'web',
      menuYn: true,
      authorization: true,
      roles: ['ADMIN']
    }
  },
  {
    path: '/partnership-inquiries/:inquiryId',
    name: '고객사·협력사 신청 상세',
    component: () => import(/* webpackChunkName: "partnershipInquiryDetail" */ '../../views/partnership/PartnershipInquiryDetail.vue'),
    meta: {
      platform: 'web',
      menuYn: true,
      authorization: true,
      roles: ['ADMIN']
    }
  }
]

export default routes
